import { observable, computed } from "mobx";
import Actions from "./actions";
import Methods from "./methods";

class ProductStoreClass extends Actions {
  constructor(props) {
    super(props);
    this.collectionIdTemp = (props && props.collectionId) || "";
    this.typeTemp = (props && props.type) || "";
    this.brandDetailsTemp = (props && props.brandDetails) || null;
  }
  @observable collectionId = this.collectionIdTemp;
  @observable type = this.typeTemp;
  @observable queryApplied = "";
  @observable callCount = 1;
  @observable isFetchingData = false;
  @observable disableFilters = false;
  @observable ProductData = null;
  @observable PdpData = null;
  // @observable recentlyViewedStyles = null;
  @observable brandDetails = this.brandDetailsTemp;
  @observable showMobileFilters = false;
  @observable tempFilters = null;
  @observable listingPageNo = 1;
  @observable
  mobileFilterToggle = {
    activeFilter: "",
    refine: false,
    sortBy: false,
  };
  @observable
  mobileTempUrlCache = {
    pathname: "",
    search: "",
  };
  @observable
  omniPincodeCache = {
    delivery_time: "",
    nearby_stores: "",
    radius: 10,
  };
  @observable sizeChartData = null;
  @computed
  get isHavingMoreProducts() {
    if (
      this.ProductData &&
      this.ProductData.totalElements -
        this.ProductData.styles.styleList.length >
        0
    ) {
      return true;
    }

    return false;
  }
  @computed
  get pdpDetails() {
    return Methods.getPdpDetails(this.PdpData);
  }
}

// const ProductStoreConst = new ProductStoreClass();

export default ProductStoreClass;



// WEBPACK FOOTER //
// ./src/stores/ProductStore/index.js